export default {"src":"/_next/static/media/3.481c8ce6.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};